
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 72 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M70.3 22.805s-12.574 9.01-34.606 9.01h.503c-22.032 0-34.607-9.01-34.607-9.01v-.2s12.575-9.01 34.607-9.01h-.503c22.032 0 34.607 9.01 34.607 9.01v.2z"}}),_c('path',{attrs:{"d":"M35.916 28.01c-4.734 0-8.572-2.42-8.572-5.406 0-2.985 3.838-5.406 8.572-5.406 4.734 0 8.571 2.42 8.571 5.406 0 2.986-3.837 5.406-8.571 5.406zm17.48 4.904c2.183 7.073 11.097 11.366 11.097 11.366 1.136-.75 2.679-3.178 2.679-3.178l.098-.152s1.396-2.516 1.51-3.867c0 0-8.074-5.707-15.355-4.205l-.03.036zM18.117 12.086c-7.297 1.427-15.31-4.362-15.31-4.362.127-1.35 1.549-3.851 1.549-3.851l.088-.158S6.012 1.302 7.155.565c0 0 8.869 4.383 10.98 11.478l-.018.043zm42.891 25.259L11.135 7.951"}})])])
          )
        }
      }
    